export const composeLoginFormShowDataLayerPayload = () => ({
    event: 'ga_event',
    eventCategory: 'form_login',
    eventAction: 'show',
});

export const composeSuccessLoginDataLayerPayload = () => ({
    event: 'ga_event',
    eventCategory: 'form_login',
    eventAction: 'login',
    eventLabel: 'success',
});

export type DataLayerPayload = ReturnType<
    | typeof composeLoginFormShowDataLayerPayload
    | typeof composeSuccessLoginDataLayerPayload
>;

export const gTag = (args: DataLayerPayload) => {
    try {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        window.dataLayer.push(args);
    } catch (error) {
        // eslint-disable-next-line
        console.error(error);
    }
};
